import type { RecurringTimelineItem } from '../../api/funds-api';

export type RecurringChargeStatus = RecurringTimelineItem['status'];

export function recurringChargeStatusColor(
  status: RecurringChargeStatus
): 'success' | 'info' | 'error' | 'warning' {
  if (status === 'charged') {
    return 'success';
  }

  if (status === 'scheduled') {
    return 'info';
  }

  if (status === 'failed') {
    return 'error';
  }

  return 'warning';
}
